<template>
  <Chart
    chartID="affect-chart"
    type="line"
    :labels="labels"
    :datasets="datasets"
    v-if="dataLoaded"
  ></Chart>
</template>

<script>
import Chart from "../../Chart.vue";

import { mapGetters } from "vuex";
import { format } from "date-fns";

export default {
  name: "Charts",
  props: ["existingEntries"],
  components: { Chart },
  data() {
    return {
      dataLoaded: false,
      labels: [],
      datasets: [
        {
          label: "Depression Level",
          data: [],
          borderColor: ["rgba(255,201,56"],
          backgroundColor: ["rgba(255,201,56"],
          fill: false,
        },
        {
          label: "Anxiety Level",
          data: [],
          borderColor: ["rgba(0,39,76)"],
          backgroundColor: ["rgba(0,39,76)"],
          fill: false,
        },
        {
          label: "Pain",
          data: [],
          backgroundColor: "gradient",
        },
      ],
    };
  },
  async mounted() {
    // Load our data and wait until it's done before setting loaded to true.
    await this.populateChart();
    this.dataLoaded = true;
  },

  computed: {
    ...mapGetters(["getPainEntries"]),
  },

  methods: {
    populateChart() {
      this.existingEntries.forEach((entry, index) => {
        // Check for matching pain entries.
        const matchingPainIndex = this.getPainEntries.findIndex(
          (painEntry) => painEntry.date.seconds === entry.date.seconds
        );

        // Add our pain entry to the dataset.
        if (matchingPainIndex > -1) {
          this.existingEntries[index].painEntry = this.getPainEntries[
            matchingPainIndex
          ];
        }
      });

      this.existingEntries
        .slice()
        .reverse()
        .forEach((entry) => {
          // Add label to chart.
          const day = format(entry.date.seconds * 1000, "MMMM D, YYYY");
          this.labels.push(day);

          // Add data to our chart.
          this.datasets[0].data.push(entry.data.downLevel);
          this.datasets[1].data.push(entry.data.anxietyLevel);

          if (entry.painEntry) {
            this.datasets[2].data.push(entry.painEntry.data.painLevel);
          } else {
            this.datasets[2].data.push("");
          }
        });
    },
  },
};
</script>

<style></style>
